import { Component, ViewChild, OnInit } from '@angular/core';
// import { Equipment, EquipmentService, EquipmentType, Provider, Providers, SitePlant, } from "../../../equipments/services/equipment.service"
import { NotificationService } from "../../common/component/notification/notification.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ContractService } from 'src/app/contracts/services/contract.service';
import { Attachment, MvaUploadItem, MvaUploadService } from '../services/mva-upload.service';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { MasterDataService } from "../../common/service/master-data.service";
import { Country } from 'src/app/common/model/shared.model';
import ArrayStore from 'devextreme/data/array_store';
import { gzip } from "pako";

@Component({
  selector: 'app-mvaupload',
  templateUrl: './mva-upload.component.html',
  styleUrls: ['./mva-upload.component.scss']
})
export class MvaUploadComponent implements OnInit {
  selectedCountries: Country[];
  selectedProducts: string[];
  types: any;
  selectedType: string;
  countriesDataSource: any;
  mvaUploadItem: MvaUploadItem;
  companyFileAttachment: Attachment[];
  prodVolumeFileAttachment: Attachment[];
  products: string[];
  countryId: string;
  productId: string;
  isLoadPanelVisible: boolean = false;
  constructor(private mvaUploadService: MvaUploadService,
    private contractService: ContractService,
    private route: ActivatedRoute,
    private router: Router,
    private masterDataService: MasterDataService,
    public notificationService: NotificationService) {
    this.isLoadPanelVisible = true;
    this.getCountries();
    this.companyFileAttachment = [];
    this.prodVolumeFileAttachment = [];
  }

  ngOnInit(): void {
    this.products = [
      'Ar',
      'N2',
      'O2',
      'CO2'
    ];
    this.types = [
      {
        "text": 'Marketing Insight (MI)',
        "value": "mi"
      },
      {
        "text": 'Multi-Variable Analysis (MVA)',
        "value": "mva"
      }
    ];
  }

  private getCountries() {
    this.masterDataService.getCountries().subscribe({
      next: countries => {
        this.countriesDataSource = new ArrayStore({
          data: countries,
          key: 'countryId',
        });
        this.isLoadPanelVisible = false;
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Countries", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  bytesToBase64(bytes) {
    var binary = '';
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  readCompanyFile(e) {
    let that = this;
    let index = 0;
    if (e.value && e.value[0]) {
      function readFile(file) {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          that.companyFileAttachment[index].fileName = file.name
          const compressed = gzip(reader.result)
          const base64Content = that.bytesToBase64(compressed)
          that.companyFileAttachment[index].content = base64Content;
          index++
        }, false);

        reader.readAsArrayBuffer(file);
      }

      if (e.value) {
        [].forEach.call(e.value, readFile);
      }
    }
  }


  readProdVolumeFile(e) {
    let that = this;
    let index = 0;
    if (e.value && e.value[0]) {
      function readFile(file) {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          that.prodVolumeFileAttachment[index].fileName = file.name
          const compressed = gzip(reader.result)
          const base64Content = that.bytesToBase64(compressed)
          that.prodVolumeFileAttachment[index].content = base64Content;
          index++
        }, false);

        reader.readAsArrayBuffer(file);
      }

      if (e.value) {
        [].forEach.call(e.value, readFile);
      }
    }
  }

  handleSubmit(e) {
    this.isLoadPanelVisible = true;
    let mvaUploadItem = new MvaUploadItem();
    mvaUploadItem.type = 'mi';
    if (this.selectedType == 'mva') {
      mvaUploadItem.type = 'mva';
      mvaUploadItem.Countries = this.selectedCountries.join();
      mvaUploadItem.Products = this.selectedProducts.join();
      mvaUploadItem.productVolFileAttachment = this.prodVolumeFileAttachment[0];
    }
    mvaUploadItem.companyFileAttachment = this.companyFileAttachment[0];
    
    this.mvaUploadService.saveMvaUploadInfo(mvaUploadItem)
      .subscribe((data: any) => {
        this.notificationService.alert("success", "Data uploaded successfully", null);
        this.isLoadPanelVisible = false;
        this.selectedCountries = [];
        this.selectedProducts = [];
        this.companyFileAttachment = null;
        this.prodVolumeFileAttachment = null;
      });
  }
}
